// docs/61 EX14: the exploration card's state the board and the HUD share — whether the journal is
// open, and the wonder just beheld (the card flashes it open as the pulse plays). docs/138 XO9: the
// briefing card — read once per encounter per browser (a localStorage mark), and opened again from
// the card's "About this place".
import { create } from 'zustand';
import { deviceNow } from '../time';

interface ExploreStore {
  journalOpen: boolean;
  /** The wonder the playback just beheld (index into `explore.wonders`) and when, to flash it. */
  flash?: { wonder: number; at: number };
  setJournal(open: boolean): void;
  flashWonder(wonder: number): void;
  /** docs/138 XO9: the briefing asked for again (About this place), for this encounter. */
  briefFor?: bigint;
  openBrief(encounterId: bigint): void;
  closeBrief(): void;
  /** Bumped when a briefing is marked read, so readers of `briefSeen` re-render. */
  rev: number;
  briefSeen(encounterId: bigint): boolean;
  setBriefSeen(encounterId: bigint): void;
}

const key = (e: bigint) => `fk.brief.${e}`;
const get = (k: string) => { try { return localStorage.getItem(k) === '1'; } catch { return false; } };
const put = (k: string) => { try { localStorage.setItem(k, '1'); } catch { /* private mode */ } };

export const useExplore = create<ExploreStore>()((set, getState) => ({
  journalOpen: false,
  rev: 0,
  setJournal(open) { set({ journalOpen: open }); },
  flashWonder(wonder) { set({ journalOpen: true, flash: { wonder, at: deviceNow() } }); },
  openBrief(encounterId) { set({ briefFor: encounterId }); },
  closeBrief() { if (getState().briefFor !== undefined) set({ briefFor: undefined }); },
  briefSeen: (e) => get(key(e)),
  setBriefSeen(e) { put(key(e)); set({ rev: getState().rev + 1 }); },
}));
